import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

import { getPayments } from '../../services/payment';
import { showAlert } from '../../store/ducks/alert';

import { formatCurrency } from '../../helpers/formatCurrency';

import { Button, CircularProgress } from '@material-ui/core';

const Payments = ({ channelId, onlyWithDraws = false }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();
  const [payments, setPayments] = useState([]);
  const [actualPage, setActualPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [orderDirections, setOrderDirections] = useState({ item: 'paymentDate', direction: 'DESC' });

  useEffect(() => {
    let page;
    let parsedParams = {};
    if (channelId) {
      parsedParams = { search: channelId, searchItem: 'toChannelId' };
    }
    if (channelId && onlyWithDraws) {
      parsedParams = { search: 'withdraw', searchItem: 'paymentType', toChannelId: channelId };
    } else {
      page = params.page || actualPage;
      if (params.search && params.searchItem) parsedParams = { ...parsedParams, search: params.search, searchItem: params.searchItem };
      setIsSearching(true);
      setSearch(parsedParams);
    }
    handleGetTransactions(page, parsedParams);
  }, []);

  const headers = ['paymentToken', 'toChannelId', 'value', 'paymentType', 'status', 'confirmed', 'isDonation', 'currency', 'paymentDate'];
  const searchBoxHeaders = [
    'toChannelId',
    'value',
    'paymentType',
    'status',
    'currency',
    'paymentDate',
    'paymentToken',
    'transactionIdInOrigin',
    'recipientId',
    'uid',
    'userEmail'
  ];

  const handleSubmitSearch = searchBox => {
    setSearch(searchBox);
    setIsSearching(true);
    handleGetTransactions(actualPage, searchBox);
  };

  const handleChangePage = async page => {
    setActualPage(page);
    handleGetTransactions(page, search);
  };

  const handleGoToWithdrawRequests = () => {
    history.push(`/withdrawRequests`);
  };

  const handleGoToDuplicatedTransactions = () => {
    history.push(`/transactions/duplicated`);
  };

  const handleGetTransactions = async (page = 0, searchObject) => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (searchObject) params = { ...searchObject, ...params };

      const { data: payments } = await getPayments(page, params);

      setPayments(
        payments.rows.map(item => {
          return { ...item, paymentUid: item.uid, value: formatCurrency(item.currency, item.value) };
        })
      );
      setTotalItems(payments.count);
      setTotalPages(payments.pages);
      setActualPage(payments.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>
          {!onlyWithDraws ? 'Transactions' : 'Withdraws'} ({totalItems})
        </h1>
        {!channelId && (
          <>
            <SearchBox
              selectItems={searchBoxHeaders}
              onSubmitSearch={handleSubmitSearch}
              isSearching={isSearching}
              onKeyDown={escape}
              setIsOrdering={setIsOrdering}
            />
          </>
        )}
      </div>

      {!channelId && (
        <div className="header-buttons">
          <Button
            color="primary"
            variant="contained"
            onClick={() => history.push({ pathname: '/recipients/search=pending&searchItem=status' })}
          >
            Recipients
          </Button>
          <Button onClick={handleGoToWithdrawRequests} variant="contained">
            Withdraw Requests
          </Button>
          <Button onClick={handleGoToDuplicatedTransactions} variant="contained">
            Duplicated Transactions
          </Button>
        </div>
      )}

      <DataTable
        head={headers}
        body={payments}
        bodyColumn={headers}
        action={true}
        useUid={true}
        linkPath={'transactions'}
        totalPages={totalPages}
        currentPage={actualPage}
        setPageChange={handleChangePage}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />
    </>
  );
};

export default Payments;
